<!-- @format -->
<div class="swatches hmf-display-flex hmf-align-items-center hmf-m-xs">
	@if (validColors()?.length) {
		@for (
			color of validColors() | slice: 0 : maxColorSwatchesToShow();
			track trackBySwatch($index, color)
		) {
			<shared-totf-components-image-swatch
				class="hmf-m-xxxs"
				radius="0"
				height="44px"
				width="44px"
				[color]="color"
				[imageSrc]="imageSrcMap[color]"
				[imageSwatchHoverDimension]="true"
				[selected]="selectedSwatchColor() === color"
				[isLazy]="isLazy()"
				(mouseover)="setImageColor(color)"
				(focus)="setImageColor(color)"
				(imageSwatchError)="
					handleImageError({ requestedImg: $event, color: color })
				"></shared-totf-components-image-swatch>
		}

		@if (validColors().length > maxColorSwatchesToShow()) {
			<button
				hmf-action-text
				variant="secondary"
				class="hmf-m-xxxs underlined-grey-button"
				[ariaLabel]="moreColorsButtonAriaLabel()"
				[linkURL]="assetSeoUrl()"
				[styled]="true"
				(click)="extraColorsClicked($event)">
				+{{ validColors().length - maxColorSwatchesToShow() }}
			</button>
		}
	}
</div>
